import { jsxs as B, jsx as o } from "react/jsx-runtime";
import { NotificationBarHeader as d } from "../NotificationBarHeader/index.js";
import { NotificationBarList as u } from "../NotificationBarList/index.js";
import { NotificationLoadMoreButton as L } from "./style.js";
function H({
  notifications: i,
  loading: t,
  hasNextPage: r,
  getNotificationUrl: n,
  onBackClick: a,
  onReadAllClick: c,
  onNotificationClick: f,
  onLoadMore: e
}) {
  const s = {
    onBackClick: a,
    onReadAllClick: c
  }, m = {
    notifications: i,
    loading: t,
    getNotificationUrl: n,
    onNotificationClick: f
  }, p = {
    onLoadMore: e,
    loading: t
  };
  return /* @__PURE__ */ B("div", { children: [
    /* @__PURE__ */ o(d, { ...s }),
    /* @__PURE__ */ o(u, { ...m }),
    r && /* @__PURE__ */ o(L, { ...p })
  ] });
}
export {
  H as NotificationBarCenter
};
